import { Typography } from '@mui/material';

type AddressTextProps = {
  zip_code: string;
  county: string;
  city: string;
  line1: string;
  line2?: string;
  line3?: string;
  name?: string;
};

function AddressText(props: AddressTextProps) {
  return (
    <>
      <Typography>
        {props.zip_code} {props.county} {props.city}
      </Typography>
      <Typography>{props.line1}</Typography>
      {props.line2 ? <Typography> {props.line2} </Typography> : <></>}
      {props.line3 ? <Typography> {props.line3} </Typography> : <></>}
      {props.name ? <Typography>{props.name} 様</Typography> : <></>}
    </>
  );
}

export default AddressText;
